import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from '../inc/header';
import Footer from '../inc/footer';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';


function ContactForm() {
    const [captchaValue, setCaptchaValue] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!captchaValue) {
            alert("Please complete the reCAPTCHA");
            return;
        }

        const formData = new FormData(e.target);

        try {
            const response = await fetch("php/contact-form.php", {
                method: "POST",
                body: formData
            });

            const result = await response.json();

            if (result.success) {
                document.querySelector(".contact-form-success").classList.remove("d-none");
                document.querySelector(".contact-form-error").classList.add("d-none");
                e.target.reset();
            } else {
                document.querySelector(".contact-form-error").classList.remove("d-none");
            }
        } catch (error) {
            document.querySelector(".contact-form-error").classList.remove("d-none");
        }
    };

    const handleCaptchaChange = (value) => {
        setCaptchaValue(value);
    };
    return (
        <>
       
        
        <div className="body text-start">
            <Helmet>
                <title>Radius Exhibition Fixtures &#8211; Interior Fit Out Company in Dubai, UAE | Signage Company - Contact</title>
                <meta name="description" content="Radius Exhibition Fixtures &#8211; Interior Fit Out Company in Dubai, UAE | Signage Company" />
                <meta property="og:title" content="Radius - Contact" />
                <meta property="og:description" content="Radius Exhibition Fixtures &#8211; Interior Fit Out Company in Dubai, UAE | Signage Company" />
            </Helmet>
            <Header />
                <div role="main" className="main">

                    <div id="googlemaps" className="google-map mt-0" style={{height: "500px"}}>
                        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3612.192292463675!2d55.241615!3d25.129189!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5d0c13832339%3A0x60b65104a1ad12f8!2sRadius%20Exhibition%20Fixtures%20Works%20LLC!5e0!3m2!1sen!2sae!4v1762586190469!5m2!1sen!2sae" style={{ border: '0', width: '100%', height: '100%' }} allowfullscreen="" loading="lazy" className='mt-5' referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
        
                    <div className="container">

                        <div className="row py-4">
                            <div className="col-lg-6">

                                <h2 className="font-weight-bold text-8 mt-2 mb-0">Contact Us</h2>
                                <p className="mb-4">Feel free to ask for details, don't save any questions!</p>

                                <form className="contact-form" action="php/contact-form.php" method="POST" onSubmit={handleSubmit}>
                                    <div className="contact-form-success alert alert-success d-none mt-4">
                                        <strong>Success!</strong> Your message has been sent to us.
                                    </div>

                                    <div className="contact-form-error alert alert-danger d-none mt-4">
                                        <strong>Error!</strong> There was an error sending your message.
                                        <span className="mail-error-message text-1 d-block"></span>
                                    </div>

                                    <div className="row">
                                        <div className="form-group col-lg-6">
                                            <label className="form-label mb-1 text-2">Full Name</label>
                                            <input type="text"  className="form-control text-3 h-auto py-2" name="name" required />
                                        </div>
                                        <div className="form-group col-lg-6">
                                            <label className="form-label mb-1 text-2">Email Address</label>
                                            <input type="email"  data-msg-email="Please enter a valid email address." className="form-control text-3 h-auto py-2" name="email" required />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col">
                                            <label className="form-label mb-1 text-2">Subject</label>
                                            <input type="text" className="form-control text-3 h-auto py-2" name="subject" required />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col">
                                            <label className="form-label mb-1 text-2">Message</label>
                                            <textarea maxlength="5000" data-msg-required="Please enter your message." rows="8" className="form-control text-3 h-auto py-2" name="message" required />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col">
                                            <input type="submit" value="Send Message" className="btn btn-pink btn-modern" data-loading-text="Loading..." />
                                        </div>
                                    </div>
                                </form>

                            </div>
                            <div className="col-lg-6">

                                <div className="">
                                    <h4 className="mt-2 mb-1">Our <strong>Office</strong></h4>
                                    <ul className="list list-icons list-icons-style-2 mt-2">
                                        <li><i className="fas fa-map-marker-alt top-6"></i> <strong className="text-dark">Address:</strong> Warehouse No. 02 - 02 33B St - Al Qouz Industrial Area 2 - Dubai, United Arab Emirates</li>
                                        <li><i className="fas fa-phone top-6"></i> <strong className="text-dark">M:</strong> : 050 345 9075 | <strong className="text-dark">T:</strong>: 04 267 5433</li>
                                        <li><i className="fas fa-envelope top-6"></i> <strong className="text-dark">Email:</strong> <a mailto="enquiry@radius.ae">contact@radius.ae</a></li>
                                    </ul>
                                </div>

                                <div className="" data-appear-animation="fadeIn" data-appear-animation-delay="950">
                                    <h4 className="pt-5">Business <strong>Hours</strong></h4>
                                    <ul className="list list-icons list-dark mt-2">
                                        <li><i className="far fa-clock top-6"></i> Monday - Friday - 9am to 5pm</li>
                                        <li><i className="far fa-clock top-6"></i> Saturday - 9am to 2pm</li>
                                        <li><i className="far fa-clock top-6"></i> Sunday - Closed</li>
                                    </ul>
                                </div>

                                
                            </div>

                        </div>

                    </div>

                </div>  

        </div>
        <Footer />
        </>
    );
}

export default ContactForm;
